export const toPersianFinancialType = {
  cash: 'نقدی',
  credit: 'اعتباری',
};
